jQuery(document).ready(function($){
    if($('.inline-btns').length) {
        $('.inline-btns').each(function(){
            let btnSize = 0;
            // let btnContainer = $(this).closest('div').width();
            let btnCount = $(this).find('a.btn').length;
            $(this).find('a.btn').each(function(){
                if($(this).innerWidth() > btnSize) {
                    btnSize = $(this).innerWidth();
                }
            });

            // if(btnContainer > ((btnSize * btnCount) + 20)) {
                $(this).find('a.btn').each(function(){
                    $(this).css('min-width', btnSize + 'px');
                });
            // }
        });
    }

    if($('.slideshow__item-wrap.dual').length) {
        $('.slideshow__item-wrap.dual').each(function(){
            const firstBG = $(this).find('.slideshow__slide-bg:first-of-type img').attr('src');
            const secondBG = $(this).find('.slideshow__slide-bg:nth-child(2) img').attr('src');

            if(firstBG) {
                $(this).find('.slideshow__content.hbr__content').addClass('KELLEY').css('background', firstBG + ' !important;');
                console.log(firstBG);
            }
            if(secondBG) {
                $(this).find('.slideshow__content + .slideshow__content').css('background-image', secondBG);
            }
        });
    }
});